import DataGrid, { Button, Column, Paging } from "devextreme-react/data-grid";
import { useCallback, useState } from "react";
import { FileTypes, KindOfOrder } from "../../../../types/enums";
import { apiDeleteFileAttachment } from "../api/delete-file-attachment";
import { FileAttachment } from "../types/FileAttachment";
import './FileAttachmentGrid.scss'
import { confirm } from 'devextreme/ui/dialog';
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import FileAttachmentUploader from "./FileAttachmentUploader";
import { FileAttachmentLink } from "../..";
import { LoadPopupPanel } from "../../../../components";

export default function FileAttachmentGrid(props:
	{
		attachedFiles: FileAttachment[],
		orderID?: number,
		parentGuid: string,
		kindOfOrder: KindOfOrder,
		orderTypeID?: number,
		defaultFileType?: FileTypes,
		fileTypeFilter?: (fileType: FileTypes) => boolean,
		useFileTypes: boolean,
		visible: boolean,
		hideDeleteButton?: boolean,
		replaceFile?: boolean,
		onFileAdded: (fileType: FileTypes) => void,
		onFileDeleted: () => void
	}) {

	const [processing, setProcessing] = useState(false);
	const [existingFileName, setExistingFileName] = useState<string | undefined>();

	const deleteFile = (data: FileAttachment) => {
		confirm(`Are you sure you want to delete ${data.fileName}?`, 'Delete File')
			.then((dialogResult) => {
				if (dialogResult) {
					setProcessing(true);
					apiDeleteFileAttachment(data.documentID, props.kindOfOrder)
						.then((result) => {
							if (result.isSuccess) {
								showSuccessMessage('The file has been deleted');
								props.onFileDeleted();
							}
							else
								showErrorMessage(result.errorMessage!);
						})
						.finally(() => setProcessing(false));
				}
			});
	}

	const rowPrepared = useCallback((e: any) => {
		if (e.rowType === "data") {
			if (e.data.fromLinkedOrder) {
				e.rowElement.classList.add("linked-order-document");
			}
		}
	}, []);

	const onFileSelected = (fileType: FileTypes) => {
		console.log(fileType);

		if (props.replaceFile && fileType === props.defaultFileType) {
			const existingFile = props.attachedFiles.find(x => x.fileTypeID === fileType);
			if (existingFile) {
				setExistingFileName(existingFile.fileName);
			}
			else {
				setExistingFileName(undefined);
			}
		}
		else {
			setExistingFileName(undefined);
		}
	};

	return (
		<div className="file-attachments">
			<DataGrid
				dataSource={props.attachedFiles}
				allowColumnResizing={true}
				showBorders={true}
				showColumnLines={true}
				columnAutoWidth={true}
				keyExpr={'documentID'}
				onRowPrepared={rowPrepared}
			>
				<Paging enabled={false} />

				<Column
					caption={'File Name'}
					dataType="string"
					width={400}
					cellRender={(row) => {
						return (
							<FileAttachmentLink
								caption={row.data.fileName}
								fileName={row.data.fileName}
								awsS3Key={row.data.awsS3Key} />
						)
					}}
				>
				</Column>
				<Column
					dataField={'fileTypeName'}
					caption={'File Type'}
					dataType="string"
					visible={props.useFileTypes}
				/>
				<Column
					dataField={'uploadDate'}
					caption={'Upload Date'}
					dataType="date"
					format="shortDateShortTime"
				/>
				<Column
					dataField={'createdBy'}
					caption={'Created By'}
					dataType="string"
				/>
				{
					!props.hideDeleteButton &&
					<Column
						type={'buttons'}
					>
						<Button
							icon='dx-icon dx-icon-remove' text={'Delete'}
							visible={(e: any) => { return e.row.data.documentID > 0; }}
							onClick={(e: any) => deleteFile(e.row.data)}
						/>
					</Column>
				}
			</DataGrid>
			<div className="dx-fieldset">
				<div className="dx-fieldset-header">Add File</div>
				<FileAttachmentUploader
					orderID={props.orderID}
					parentGuid={props.parentGuid}
					kindOfOrder={props.kindOfOrder}
					orderTypeID={props.orderTypeID}
					defaultFileType={props.defaultFileType}
					fileTypeFilter={props.fileTypeFilter}
					useFileTypes={props.useFileTypes}
					replaceFile={props.replaceFile}
					visible={props.visible}
					onFileSelected={onFileSelected}
					onFileAdded={props.onFileAdded}
					onProcessing={(processing) => setProcessing(processing)}
				/>
			</div>
			{
				existingFileName &&
				<div className="existing-file-warning">
					New upload file will replace existing file, <b>{existingFileName}</b>
				</div>
			}

			<LoadPopupPanel visible={processing}></LoadPopupPanel>
		</div>
	);
}

